import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff129f6a")

_pushScopeId("data-v-ff129f6a")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_4 = {
  for: "comment",
  class: "form-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12 fv-row" }
const _hoisted_8 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-1" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a objective's title"
}, null, -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-12 fv-row" }
const _hoisted_15 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a objective's title"
}, null, -1)
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "fs-6 fw-bold form-label" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "fs-6 fw-bold form-label" }
const _hoisted_22 = { class: "button-container" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "checkbox-container" }
const _hoisted_29 = { class: "checkbox-label" }
const _hoisted_30 = { class: "checkbox-container" }
const _hoisted_31 = {
  key: 0,
  class: "skeleton"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: "/media/icons/new/checked.png",
  width: "20",
  height: "20",
  alt: "yes"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: "/media/icons/new/unchecked.png",
  width: "20",
  height: "20",
  alt: "no"
}, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_35 = {
  key: 0,
  class: "date-text"
}
const _hoisted_36 = { class: { 'date-text': true } }
const _hoisted_37 = {
  key: 1,
  class: "date-text"
}
const _hoisted_38 = {
  key: 2,
  class: "date-text"
}
const _hoisted_39 = {
  class: "modal fade",
  id: "_app_remove_confirm_modal",
  tabindex: -1,
  "aria-hidden": "true"
}
const _hoisted_40 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = { class: "svg-icon svg-icon-1" }
const _hoisted_44 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-5 text-center" }
const _hoisted_45 = { class: "my-9" }
const _hoisted_46 = { class: "actions text-center" }
const _hoisted_47 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_Form = _resolveComponent("Form")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($setup.showSpinner)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", {
            class: "mb-3 commitment-title",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.editing = true)),
            style: {"display":"flex","justify-content":"space-between","align-items":"center"}
          }, [
            _createVNode("label", _hoisted_4, _toDisplayString($setup.editing && $setup.selectedCommitment.id != 0
        ? $setup.translate("editTask")
        : $setup.adding && $setup.editing
          ? $setup.translate("newTask")
          : $setup.translate("Commitments")), 1)
          ]),
          ($setup.editing)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_Form, {
                  id: "kt_invitation_form",
                  class: "form",
                  onSubmit: $setup.saveCommitment
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("label", _hoisted_8, [
                          _createVNode("span", _hoisted_9, _toDisplayString($setup.translate("objectiveTitle")), 1),
                          _hoisted_10
                        ]),
                        _createVNode(_component_Field, {
                          id: "focusTitle",
                          ref: "textInput",
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "title",
                          modelValue: $setup.selectedCommitment.title,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.selectedCommitment.title = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _createVNode(_component_ErrorMessage, { name: "title" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("label", _hoisted_15, [
                          _createVNode("span", null, _toDisplayString($setup.translate("description")), 1),
                          _hoisted_16
                        ]),
                        _createVNode(_component_el_input, {
                          modelValue: $setup.selectedCommitment.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.selectedCommitment.description = $event)),
                          type: "textarea",
                          rows: "2",
                          name: "description",
                          placeholder: $setup.translate('objectiveDescriptions'),
                          id: "description"
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("label", _hoisted_19, _toDisplayString($setup.translate("startsAt")), 1),
                        _createVNode(_component_el_date_picker, {
                          modelValue: $setup.selectedCommitment.start_at,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.selectedCommitment.start_at = $event)),
                          "disabled-date": $setup.datePickerStartAtOptions,
                          class: "el-date-picker",
                          type: "date",
                          placeholder: $setup.translate('startsAt')
                        }, null, 8, ["modelValue", "disabled-date", "placeholder"])
                      ]),
                      _createVNode("div", _hoisted_20, [
                        _createVNode("label", _hoisted_21, _toDisplayString($setup.translate("endsAt")), 1),
                        _createVNode(_component_el_date_picker, {
                          modelValue: $setup.selectedCommitment.end_at,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.selectedCommitment.end_at = $event)),
                          "disabled-date": $setup.datePickerEndAtOptions,
                          class: "el-date-picker",
                          type: "date",
                          placeholder: $setup.translate('endsAt')
                        }, null, 8, ["modelValue", "disabled-date", "placeholder"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("button", _hoisted_24, _toDisplayString($setup.translate("Save")), 1),
                        _createVNode("button", {
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.cancelEdit && $setup.cancelEdit(...args))),
                          class: "btn btn-secondary"
                        }, _toDisplayString($setup.translate("Cancel")), 1)
                      ]),
                      (!$setup.adding)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _createVNode("button", {
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#_app_remove_confirm_modal",
                              "data-bs-placement": "top",
                              class: "btn btn-danger mt-2 ml-2 btn-primary-action"
                            }, _toDisplayString($setup.translate("Delete")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode("div", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.addNewCommitment && $setup.addNewCommitment(...args))),
                  class: "mb-2"
                }, [
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: $setup.translate('addCommitment'),
                    name: "title readonly"
                  }, null, 8, ["placeholder"])
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList([...$setup.commitments].reverse(), (commitment, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "card"
                  }, [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", _hoisted_28, [
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            ($setup.showSkeleton[index])
                              ? (_openBlock(), _createBlock("div", _hoisted_31))
                              : (_openBlock(), _createBlock("div", {
                                  key: 1,
                                  class: "checkbox-wrapper",
                                  onClick: ($event: any) => (
      $setup.handleCheckboxChange(
        commitment.id,
        commitment.status,
        index
      ))
                                }, [
                                  _createVNode("div", null, [
                                    _withDirectives(_createVNode("span", null, [
                                      _hoisted_32
                                    ], 512), [
                                      [_vShow, commitment.status]
                                    ]),
                                    _withDirectives(_createVNode("span", null, [
                                      _hoisted_33
                                    ], 512), [
                                      [_vShow, !commitment.status]
                                    ])
                                  ])
                                ], 8, ["onClick"])),
                            _createVNode("span", {
                              onClick: _withModifiers(($event: any) => ($setup.editCommitment(commitment)), ["stop"]),
                              class: "comment-text"
                            }, _toDisplayString(commitment.title), 9, ["onClick"])
                          ])
                        ]),
                        ($setup.isValidDateRange(commitment.start_at, commitment.end_at))
                          ? (_openBlock(), _createBlock("div", _hoisted_34, [
                              ($setup.isInvalidDate(commitment.end_at))
                                ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString($setup.translate("startsAt")) + ":  ", 1))
                                : _createCommentVNode("", true),
                              _createVNode("span", _hoisted_36, _toDisplayString($setup.formatDateIfExists(commitment.start_at)), 1),
                              ($setup.isDateRange(commitment.start_at, commitment.end_at))
                                ? (_openBlock(), _createBlock("span", _hoisted_37, " - "))
                                : _createCommentVNode("", true),
                              ($setup.isInvalidDate(commitment.start_at))
                                ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString($setup.translate("endsAt")) + ":  ", 1))
                                : _createCommentVNode("", true),
                              _createVNode("span", {
                                class: { 'date-text': true, overdue: $setup.isDateOverdue(commitment.end_at) }
                              }, _toDisplayString($setup.formatDateIfExists(commitment.end_at)), 3)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])),
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("h3", null, _toDisplayString($setup.translate("removingConfirmationTitle")), 1),
                  _createVNode("button", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.cancelDeleteCommitment && $setup.cancelDeleteCommitment(...args))),
                    type: "button",
                    class: "btn btn-sm btn-icon btn-active-color-primary"
                  }, [
                    _createVNode("span", _hoisted_43, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("h2", null, _toDisplayString($setup.translate("removeCommitment")), 1),
                  _createVNode("h5", _hoisted_45, _toDisplayString($setup.selectedCommitment.title), 1),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.confirmRemoveCommitment && $setup.confirmRemoveCommitment(...args)))
                    }, [
                      _createVNode("span", _hoisted_47, _toDisplayString($setup.translate("confirm")), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 64))
  ]))
})